import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { ProposalDomainData } from 'store/modules/proposal/proposalDomainModule';
import { action, computed, makeObservable, observable } from 'mobx';
import { saveGenerateProposalAnswers } from 'api/operations/proposalServiceV3';
import { Primitive } from 'types/general';
import { IStepController } from './iStepController';

export interface FirstStepFields extends DefaultFormFields {
  includePlanDetails: FormControl<boolean>;
  includeRatesBlock: FormControl<boolean>;
  includeBC: FormControl<boolean>;
  productAttributesSetting: FormControl<ProductAttributeOption>;
  includeRateSheet: FormControl<boolean>;
  includeRateSheetBC: FormControl<boolean>;
  includeRateSheetPlanHighlights: FormControl<boolean>;
}

type FirstFormController = FormController<FirstStepFields>;

export type ProductAttributeOption = 'all' | 'plan-highlights-only';

export default class FirstStepController extends IStepController {
  private _form = new FormController<FirstStepFields>({
    includePlanDetails: new FormControl<boolean>(true, { optional: true }),
    includeRateSheetBC: new FormControl<boolean>(true, { optional: true }),
    includeRateSheetPlanHighlights: new FormControl<boolean>(true, { optional: true }),
    includeRatesBlock: new FormControl<boolean>(true, { optional: true }),
    includeBC: new FormControl<boolean>(true, { optional: true }),
    productAttributesSetting: new FormControl<ProductAttributeOption>('all', { optional: true }),
    includeRateSheet: new FormControl<boolean>(true, { optional: true }),
    includeProductLogo: new FormControl<boolean>(false, { optional: true }),
  });

  get isValid(): boolean {
    return this._form.isFormValid();
  }

  get form(): FirstFormController {
    return this._form;
  }

  public updateFormData(formData: Record<string, Primitive>): void {
    this._form.populateFields(formData);
  }

  async completeStep(domainData: ProposalDomainData): Promise<void> {
    const {
      includePlanDetails,
      includeRatesBlock,
      includeBC,
      productAttributesSetting,
      includeRateSheet,
      includeRateSheetBC,
      includeRateSheetPlanHighlights,
      includeProductLogo,
    } = this._form.getFormDataObject();

    const sanitatedValues = {
      includePlanDetails,
      productAttributesSetting,
      includeRateSheet,
      includeRateSheetBC: includeRateSheet === true ? includeRateSheetBC : false,
      includeRateSheetPlanHighlights: includeRateSheet === true ? includeRateSheetPlanHighlights : false,
      includeRatesBlock: includePlanDetails === true ? includeRatesBlock : false,
      includeBC: includePlanDetails === true ? includeBC : false,
      includeProductLogo,
    };

    await saveGenerateProposalAnswers(domainData.cart.id, sanitatedValues as Record<string, Primitive>);
  }

  constructor() {
    super();
    makeObservable<FirstStepController, '_form'>(this, {
      _form: observable,
      isValid: computed,
      form: computed,
      completeStep: action.bound,
    });
  }
}
